<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg pt-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="title"/>
          </h5>
        </div>
      </div>
    </div>
    <image-gallery v-if="isGalleryLoaded" :galleryItems="imageGallery"/>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "../components/navBar";

import ImageGallery from "../components/imageGallery";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

// let allPhotos = null;

export default {
  name: "photoGallery",
  metaInfo: {
    title: 'ماشین سازان اصلانیان-گالری تصاویر'
  },
  components: {PageTitle, FooterMenu, ImageGallery, NavBar},
  data: () => ({
    showLoaderDialog: false,
    imageGallery: null,
    isGalleryLoaded: false,
    title: 'گالری تصاویر'
  }),
  mounted: function () {

    this.getData()

    document.addEventListener("keydown", e => {
      if (this.isShowPhoto && e.keyCode == 27) {
        this.isShowPhoto = false;
      }
    });
  },

  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Gallery", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            //this.photos = json;
            this.imageGallery = json;
            this.showLoaderDialog = false;
            this.isGalleryLoaded = true

          })
          .catch(error => console.log('error', error));
    }

  }

};
/**
 * Get photos from pexels.com and generate urls by ids
 * @return array [{urlThumbnail, urlPhoto, idx}, ...]
 */


</script>

<style scoped>

</style>